import { useState, useEffect } from "react";

// Simple localStorage-backed cart keyed by user
function loadCart() {
  try { return JSON.parse(localStorage.getItem("cart") || "[]"); } catch { return []; }
}
function saveCart(items) {
  localStorage.setItem("cart", JSON.stringify(items));
  window.dispatchEvent(new Event("cart:changed"));
}

export function useCart() {
  const [items, setItems] = useState(loadCart);

  useEffect(() => {
    const handler = () => setItems(loadCart());
    window.addEventListener("cart:changed", handler);
    return () => window.removeEventListener("cart:changed", handler);
  }, []);

  const add = (item) => {
    const next = [...items];
    const idx = next.findIndex((x) => x.product_id === item.product_id && x.variant_name === item.variant_name);
    if (idx >= 0) next[idx].quantity += item.quantity;
    else next.push(item);
    saveCart(next);
  };
  const remove = (i) => {
    const next = items.filter((_, idx) => idx !== i);
    saveCart(next);
  };
  const updateQty = (i, q) => {
    const next = items.map((x, idx) => (idx === i ? { ...x, quantity: Math.max(1, q) } : x));
    saveCart(next);
  };
  const clear = () => saveCart([]);
  const subtotal = items.reduce((s, x) => s + x.price * x.quantity, 0);
  return { items, add, remove, updateQty, clear, subtotal };
}
